import React, { useContext } from 'react';
import classNames from 'classnames';

import logo from '../../../assets/logos/Brand.svg';
import mark from '../../../assets/logos/Brandmark.svg';
import logoPride from '../../../assets/logos/JL_Pride_Logo_2021.png';
import brandMarkPride from '../../../assets/logos/JL_Pride_2021_Brandmark.png';
import styles from './logo.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import isMonetateGroup from '../../utils/monetate/isMonetateGroup';

export const logoAssetsPath = assetsPath => asset =>
  assetsPath ? `${assetsPath}/images/${asset.split('/').pop()}` : asset;

const getLogoSrc = (features, assetsPath, showMark) => {
  const prideLogoActive = isMonetateGroup(features, 'enable pride logo');
  const logoWithAssetsPath = logoAssetsPath(assetsPath);

  if (prideLogoActive) {
    return showMark
      ? logoWithAssetsPath(brandMarkPride)
      : logoWithAssetsPath(logoPride);
  }

  return showMark ? logoWithAssetsPath(mark) : logoWithAssetsPath(logo);
};

const Logo = ({ showMark, slimMobileHeader, splashScreen }) => {
  const { features, envVars } = useContext(EnvVarsFeaturesContext);

  const logoClasses = classNames(
    splashScreen
      ? {
          [styles.logoExpandedSearch]: !slimMobileHeader,
          [styles.mark]: showMark && !slimMobileHeader,
          [styles.slimLogo]: slimMobileHeader,
        }
      : {
          [styles.logo]: !slimMobileHeader,
          [styles.mark]: showMark && !slimMobileHeader,
          [styles.slimLogo]: slimMobileHeader,
        }
  );

  const logoSrc = getLogoSrc(features, envVars.assetsPath, showMark);

  return (
    <div
      className={
        splashScreen ? styles.containerExpandedSearch : styles.container
      }
    >
      <a className={styles.link} href="/">
        <img
          className={logoClasses}
          src={logoSrc}
          alt="John Lewis & Partners Home"
        />
      </a>
    </div>
  );
};

export default Logo;
